module.exports = __webpack_public_path__ + "img/process3.747b439c.png";